import { render, staticRenderFns } from "./DriverRates.vue?vue&type=template&id=c9d4c422"
import script from "./DriverRates.vue?vue&type=script&lang=js"
export * from "./DriverRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports